// @ts-nocheck
import * as types from '../types';

const initialState = {
    list: [],
    selected: {
        details: {},
        recipients: [],
    },
    filters: {
        keyword: '',
    },
};

const messages = (state = initialState, action) => {
    const { payload } = action;

    switch (action.type) {
        case types.MESSAGES_FETCHED:
            return {
                ...state,
                list: payload,
            };
        case types.MESSAGES_CLEARED:
            return {
                ...state,
                list: initialState.list,
            };
        case types.MESSAGE_DETAILS_FETCHED:
            return {
                ...state,
                selected: payload,
            };
        case types.MESSAGE_DETAILS_CLEARED:
            return {
                ...state,
                selected: initialState.selected,
            };
        case types.MESSAGE_FILTERS_CHANGED:
            return {
                ...state,
                filters: {
                    ...state.filters,
                    ...payload,
                },
            };
        default:
            return state;
    }
};

export default messages;
